import { useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import { EssayViewModel } from '../../essay.vm';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;

  @media (max-width: 640px) {
    padding: 0;
    align-items: end;
  }
`;

const ModalContent = styled.div`
  position: relative;
  background: #333;
  padding: 32px;
  border-radius: 32px;
  max-width: 859px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  height: 100vh;
  max-height: 290px;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
    max-height: unset;
  }
`;

const CloseButton = styled.button`
  font-size: 50px;
  line-height: 1;
  position: absolute;
  padding: 20px;
  right: 0;
  top: 0;
`;

const ModalEssayContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

const ModalTitle = styled.h2`
  font-family: Aprova Nova;
  font-size: 32px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-top: 24px;
  }
`;

const ModalSubTitle = styled.h3`
  font-family: Aprova Nova;
  font-size: 24px;
  font-weight: 400;
  line-height: 28.8px;
  text-align: center;
  color: #999999;
`;

const ModalEssayButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const DetailsButton = styled.button<{ buttonStyle: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 28px 20px 32px;
  border-radius: 300px;
  margin: 16px 16px 0 0;
  align-self: flex-end;

  color: ${(props) => (props.buttonStyle === 'cancel' ? `#FFFFFF` : `#000000`)};
  background-color: ${(props) => (props.buttonStyle === 'cancel' ? `none` : `#FF7572`)};
  border: ${(props) => props.buttonStyle === 'cancel' && '1px solid #fff'};

  span {
    font-weight: 700;
    font-size: 20px;
    line-height: 14px;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  path {
    fill: black;
    max-width: 14px;
    max-height: 14px;
  }

  @media (max-width: 768px) {
    align-self: unset;
  }
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const SendEssayMediaAgainModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const vm = useViewModel(EssayViewModel);

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton type="button" onClick={onClose}>
          &times;
        </CloseButton>

        <ModalEssayContent>
          <ModalTitle>Reenviar Imagem?</ModalTitle>
          <ModalSubTitle>
            Você está prestes a reenviar a imagem da sua redação. Isso vai apagar todo o progresso
            atual. Tem certeza que deseja continuar?
          </ModalSubTitle>
          <ModalEssayButtonsContainer>
            <DetailsButton
              disabled={false}
              buttonStyle="cancel"
              type="button"
              onClick={() => vm.setIsSendEssayMediaAgainModalOpen(false)}
            >
              <span>Cancelar</span>
            </DetailsButton>
            <DetailsButton
              disabled={false}
              type="button"
              buttonStyle="sendAgain"
              onClick={() => {
                vm.setIsSendEssayMediaAgainModalOpen(false);
                vm.setIsEssayMediaModalOpen(true);
              }}
            >
              <span>Reenviar imagem</span>
            </DetailsButton>
          </ModalEssayButtonsContainer>
        </ModalEssayContent>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SendEssayMediaAgainModal;
